<script setup lang="ts">
import { BaseDisclosure as Disclosure } from '@/ui/accordion'
import type { Icons } from '@/components/base/BaseIcon.vue'

withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    icon: Icons
    activeFiltersCount?: number
  }>(),
  {
    activeFiltersCount: 0
  }
)
</script>

<template>
  <Disclosure :is-default-open="activeFiltersCount !== 0" :has-border="true" titlePaddings="p-6">
    <template #title>
      <div class="flex w-full items-center justify-between">
        <div class="flex items-center gap-4">
          <span class="rounded-md w-11 h-11 bg-primary/10 flex items-center justify-center">
            <BaseIcon :name="icon" class="h-6 w-6 text-primary" />
          </span>
          <div class="flex flex-col gap-1">
            <h2 class="font-medium text-base text-foreground">
              {{ title }}
            </h2>
            <p v-if="subtitle" class="text-sm font-normal text-foreground-secondary">
              {{ subtitle }}
            </p>
          </div>
        </div>
        <span
          v-if="activeFiltersCount > 0"
          :class="[
            'mr-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary'
          ]"
        >
          {{ activeFiltersCount }}
        </span>
      </div>
    </template>

    <div class="space-y-5 overflow-visible p-5">
      <slot />
    </div>
  </Disclosure>
</template>
